module.exports = __webpack_public_path__ + "assets/img/lock.abab9ef6.png";